var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Box, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const StyledContainer = styled(Box)(() => ({
    flexGrow: 1,
}));
const StyledListItem = styled(ListItem)(() => ({
    display: "block",
}));
const StyledListItemButton = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
    minHeight: convertPxToRem(48),
    paddingLeft: convertPxToRem(12),
    paddingRight: convertPxToRem(12),
    paddingTop: convertPxToRem(10),
    paddingBottom: convertPxToRem(10),
    justifyContent: "initial",
    backgroundColor: selected ? theme.palette.midribGreen.main : "unset",
    borderRadius: convertPxToRem(6),
    "&:hover": {
        backgroundColor: selected
            ? theme.palette.midribGreen.main
            : theme.palette.treezGreen[2],
    },
    "&:focus": {
        outline: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlack.main}`,
    },
    "&:disabled": {
        color: theme.palette.disabledText.main,
    },
    "&.Mui-focusVisible": {
        outline: `${convertPxToRem(1)} solid ${theme.palette.primaryBlack.main}`,
        outlineOffset: convertPxToRem(-1),
        backgroundColor: selected
            ? theme.palette.midribGreen.main
            : theme.palette.treezGreen[2],
    },
}));
const StyledListItemTextContent = styled(ListItemText)(({ theme }) => ({
    "& .MuiListItemText-primary": Object.assign({}, theme.typography.mediumText),
}));
export const SidebarTab = (_a) => {
    var { disabled = false, testId = "sidebar-nav-tab", label, selected = false } = _a, rest = __rest(_a, ["disabled", "testId", "label", "selected"]);
    return (_jsx(StyledContainer, { children: _jsx(StyledListItem, Object.assign({ disablePadding: true, "data-testid": testId }, { children: _jsx(StyledListItemButton, Object.assign({}, rest, { selected: selected, disabled: disabled }, { children: _jsx(StyledListItemTextContent, { primary: label }) })) })) }));
};
